import React from 'react';

const BdAdminPage = () => {
  return (
    <div>
      <h1>Acceso permitido</h1>
      <h4>Saludos, ya puedes insertar, modificar y eliminar registros.
      Por seguridad, no olvides pulsar el botón Logout al terminar.</h4>
    </div>
  );
};

export default BdAdminPage;